export default __webpack_public_path__ + "static/media/balance-evals-default-settings.4d0cfd4a.md";